"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPlayer = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const icons_1 = require("@shared-modules/components/icons");
require("./styles.scss");
const VideoPlayer = (props) => {
    const { src, preview, className, onPlay, onPause, onReset } = props;
    const urlSource = typeof src === "string" ? src : undefined;
    const sources = typeof src === "object" ? src : [];
    const videoRef = (0, react_1.useRef)(null);
    const [isVideoStarted, setIsVideoStarted] = (0, react_1.useState)(false);
    const playVideo = () => {
        var _a;
        onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.play();
        setIsVideoStarted(true);
    };
    const resetVideo = () => {
        onReset === null || onReset === void 0 ? void 0 : onReset();
        setIsVideoStarted(false);
    };
    const imageClassNames = (0, classnames_1.default)("c-video-player__preview", className, {
        "c-video-player__preview--hidden": isVideoStarted,
    });
    const videoClassNames = (0, classnames_1.default)("c-video-player__video", { "c-video-player__video--hidden": !isVideoStarted }, className);
    return (React.createElement("div", { className: "c-video-player" },
        preview && React.createElement("img", { className: imageClassNames, src: preview }),
        React.createElement("video", { ref: videoRef, onEnded: resetVideo, className: videoClassNames, controls: true, playsInline: true, src: urlSource, preload: "metadata", onPause: onPause, onPlay: onPlay, controlsList: "nodownload" },
            sources.map(({ src, type }) => (React.createElement("source", { src: src, type: type }))),
            "Your browser does not support the video tag."),
        !isVideoStarted && (React.createElement("div", { onClick: playVideo, className: "c-video-player__play" },
            React.createElement(icons_1.PlayIcon, { scale: 1 })))));
};
exports.VideoPlayer = VideoPlayer;
